import {
  BreakpointConfigType,
  DesignTokenSizeEnum,
  GallerySlide,
  ThemeName,
  ThemeProvider,
  styled,
} from '@volkswagen-onehub/components-core';
import { CarouselNavigation } from '@tribal-worldwide-london/ui-component-library-vwg';
import { Carousel } from '@/modules/components';
import CTACard, { CTACardProps } from '@/modules/components/CTACard/CTACard';

import useResize from '@/hooks/useResize';
import {
  getBulletLabels,
  getCurrentSlidesPerPage,
  getNumberOfBullets,
} from '@/modules/components/Carousel/Carousel';
import { useState } from 'react';

interface CTACardCarouselProps {
  ctaCardData: CTACardProps[];
  id: string;
  ariaLabel: string;
  slidesPerPage: number | BreakpointConfigType<number>;
  theme?: ThemeName;
  hideNavigationDesktop?: boolean;
  bulletPrefix: string;
}

const CTACardCarouselWrapper = styled.div(
  ({ theme }) => `
  color: ${theme.colors.content.primary};
  [aria-roledescription='slide'] > div {
    height: 100%;
  }

  *:focus {
    box-shadow: none;
  }
`
);

function CTACardCarousel(props: CTACardCarouselProps) {
  const {
    ctaCardData,
    ariaLabel,
    id,
    hideNavigationDesktop,
    slidesPerPage,
    theme = 'main',
    bulletPrefix,
    ...restProps
  } = props;

  const [currentSlide, setCurrentSlide] = useState(1);

  const resizeDimensions = useResize();

  const currentSlidesPerPage = getCurrentSlidesPerPage(
    slidesPerPage,
    resizeDimensions.innerWidth
  );

  const numberOfBullets = getNumberOfBullets(
    +currentSlidesPerPage,
    ctaCardData
  );
  const bulletLabels = getBulletLabels(numberOfBullets, bulletPrefix);

  return (
    <CTACardCarouselWrapper>
      <ThemeProvider variant="v26" theme={theme}>
        <Carousel
          {...restProps}
          id={id}
          aria-label={ariaLabel}
          gutter={DesignTokenSizeEnum.static350}
          slidesPerPage={slidesPerPage}
          bottomElements={
            <CarouselNavigation
              aria-label={`Navigation for ${ariaLabel}`}
              bulletLabels={bulletLabels}
              hideNavigationDesktop={hideNavigationDesktop}
              //disabledNext={currentSlide + 1 >= numberOfBullets}
            />
          }
          onSlideChange={(i: number) => setCurrentSlide(i)}
        >
          {ctaCardData.map((feature) => (
            <GallerySlide aria-labelledby={ariaLabel} key={feature.title}>
              <ThemeProvider variant="v26" theme="main">
                <CTACard {...feature} onClick={feature.onClick} />
              </ThemeProvider>
            </GallerySlide>
          ))}
        </Carousel>
      </ThemeProvider>
    </CTACardCarouselWrapper>
  );
}

export default CTACardCarousel;
